<template>
  <button class="button is-info" :class="size" @click="$router.go(-1)">Back</button>
</template>

<script>
export default {
  props: {
    size: { default: 'is-small' }
  }
}
</script>
